import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
  Zoom,
} from '@mui/material';

import React from 'react';



const ReactivateModal = ({
  openReactivateDialog,
  reactivateMemberCloseDialog,
  handleActivateMember,
  activateMemberLoading,
}) => {
  return (
    <>
      <Dialog
        open={openReactivateDialog}
        onClose={reactivateMemberCloseDialog}
        aria-labelledby="reactivate-member-dialogue"
      >
        <DialogTitle id="reactivate-dialog-title">{'Reactivate member?'}</DialogTitle>

        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Reactivating this member will restore member details and attendance history before it was deleted.
          </DialogContentText>
        </DialogContent>

        {/* ACTION BUTTONS */}
        <DialogActions>
          <Button onClick={reactivateMemberCloseDialog} sx={{ color: '#4B4B8E' }}>
            Cancel
          </Button>
          <Tooltip placement="top" TransitionComponent={Zoom}>
            <Button onClick={handleActivateMember} sx={{ color: '#000080' }} disabled={activateMemberLoading}>
              {activateMemberLoading ? <CircularProgress size={24} color="inherit" /> : 'Reactivate'}
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ReactivateModal;
